import { createEvent, restore, sample } from 'effector'

import { ActionStatusGiftOrder } from './types'
import { giftOrderMounted, submitGiftOrderStatus } from '../../details/model'
import { EGiftOrderStatuses, EGiftOrderStatusesCodes } from '../../const'
import { $params } from '../../../../../features/router'

export const mounted = createEvent()
export const unmounted = createEvent()
export const setAction = createEvent<string>()
export const $action = restore<string>(setAction, '')
export const submitActionStatus = createEvent<ActionStatusGiftOrder>()

sample({
  clock: submitActionStatus,
  fn: ({ id, managerComment, status }) => {
    return {
      body: {
        requestId: id,
        status:
          EGiftOrderStatusesCodes[
            status as keyof typeof EGiftOrderStatusesCodes
          ],
        managerComment,
      },
      url: `/giftshop/gift_order/${id}`,
    }
  },
  target: submitGiftOrderStatus,
})

sample({
  clock: submitGiftOrderStatus.done,
  source: $params,
  filter: (params) => Boolean(params?.giftOrderID),
  fn: () => undefined,
  target: giftOrderMounted,
})
